import {ComponentType, ReactElement} from 'react'
import {I18nContextValues, Trans, withNamespaces} from 'react-i18next'
import {Link} from 'react-router-dom'
import {flowRight as compose} from 'lodash'
import {Grid, withStyles, StyledComponentProps} from '@material-ui/core'
import messages from '../../../../../assets/messages'
import NotificationBar from '../../../../Common/NotificationBar'
import {BrokereeCopyTradingOffer} from '../../types'
import {styles} from './styles'

type BrokereeCopyTradingNotificationBaseProps = {
  accountId: string
  offer: BrokereeCopyTradingOffer
}

type BrokereeCopyTradingNotificationProps = StyledComponentProps & I18nContextValues & BrokereeCopyTradingNotificationBaseProps

const Component = (props: BrokereeCopyTradingNotificationProps): ReactElement | null => {
  const {classes = {}, accountId, offer} = props

  if (offer.isUnsubscribePending) return null

  return (
    <Grid item xs={12}>
      <NotificationBar status="success">
        <Trans {...messages.copyTradingSuggestion}
          values={{ibAccount: offer.provider.account.remoteId}}
          components={[
            <Link to={`${accountId}/copyTrading`} className={classes.link}> </Link>
          ]}/>
      </NotificationBar>
    </Grid>
  )
}

export const BrokereeCopyTradingNotification: ComponentType<BrokereeCopyTradingNotificationBaseProps> = compose(
  withStyles(styles),
  withNamespaces()
)(Component)
